import React from 'react';

const CoachIcon = ({ className = "w-6 h-6", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}
  >
    {/* Cap button on top */}
    <circle cx="12" cy="2.5" r="0.8" fill="currentColor" />
    
    {/* Cap top dome */}
    <path d="M7 7c0-2.5 2.2-4 5-4s5 1.5 5 4" />
    
    {/* Cap visor/brim */}
    <path d="M6 7h12" />
    <path d="M5 7c0 0.8 0.5 1.5 1.5 1.5h11c1 0 1.5-0.7 1.5-1.5" />
    
    {/* Head/face outline */}
    <path d="M7.5 8.5c0 0 -0.5 1.5 -0.5 3c0 2 1.5 3.5 5 3.5s5-1.5 5-3.5c0-1.5-0.5-3-0.5-3" />
    
    {/* Neck */}
    <path d="M10 15v1.5" />
    <path d="M14 15v1.5" />
    
    {/* Whistle */}
    <circle cx="12" cy="18" r="1.2" />
    <path d="M12 16.5v0.3" />
    <path d="M10.8 18h-0.5" />
    
    {/* Shoulders and shirt */}
    <path d="M10 16.5c-3 0.5-6 1.5-6 4v1.5h16v-1.5c0-2.5-3-3.5-6-4" />
    
    {/* Shirt collar */}
    <path d="M10 16.5l2 1.5l2-1.5" />
    
    {/* Sleeve stripes */}
    <path d="M4.5 20h1.5" />
    <path d="M18 20h1.5" />
  </svg>
);

export default CoachIcon;
